import React from 'react';
import { Link } from 'react-router-dom';
import { X, Trash2, Minus, Plus, ShoppingBag } from 'lucide-react';
import { useCart } from '../context/CartContext';
import { formatPrice } from '../lib/format';

const CartDrawer = () => {
  const { cart, isCartOpen, setIsCartOpen, removeFromCart, updateQty, totalPrice } = useCart();

  return (
    <>
      <div
        className={`fixed inset-0 bg-black/50 z-[70] transition-opacity duration-300 ${
          isCartOpen ? 'opacity-100 visible' : 'opacity-0 invisible'
        }`}
        onClick={() => setIsCartOpen(false)}
      />
      <aside
        className={`fixed top-0 right-0 h-full w-full max-w-md bg-white shadow-2xl z-[80] flex flex-col transition-transform duration-300 ${
          isCartOpen ? 'translate-x-0' : 'translate-x-full'
        }`}
      >
        <div className="flex items-center justify-between p-5 border-b">
          <h3 className="text-lg font-serif font-bold flex items-center gap-2">
            <ShoppingBag className="w-5 h-5 text-amber-600" />
            Coșul meu
          </h3>
          <button onClick={() => setIsCartOpen(false)} className="p-1 hover:bg-neutral-100 rounded-full">
            <X className="w-5 h-5" />
          </button>
        </div>

        <div className="flex-1 overflow-y-auto p-5">
          {cart.length === 0 ? (
            <div className="flex flex-col items-center justify-center h-full text-center text-neutral-500">
              <ShoppingBag className="w-16 h-16 text-neutral-300 mb-4" />
              <p className="font-medium">Coșul tău este gol</p>
              <p className="text-sm mt-1">Adaugă produse pentru a continua</p>
              <button
                onClick={() => setIsCartOpen(false)}
                className="mt-6 px-6 py-2.5 bg-amber-500 hover:bg-amber-600 text-white text-sm font-medium rounded-full transition-colors"
              >
                Continuă cumpărăturile
              </button>
            </div>
          ) : (
            <div className="space-y-4">
              {cart.map((item) => (
                <div key={item.id} className="flex gap-3 pb-4 border-b border-neutral-100">
                  <img
                    src={item.image}
                    alt={item.name}
                    className="w-20 h-20 object-cover rounded-lg bg-neutral-50"
                  />
                  <div className="flex-1 min-w-0">
                    <Link
                      to={`/produs/${item.slug}`}
                      onClick={() => setIsCartOpen(false)}
                      className="text-sm font-medium text-neutral-900 line-clamp-2 hover:text-amber-700"
                    >
                      {item.name}
                    </Link>
                    <div className="mt-1 text-amber-600 font-semibold text-sm">
                      {formatPrice(item.price)}
                    </div>
                    <div className="mt-2 flex items-center justify-between">
                      <div className="flex items-center border border-neutral-200 rounded-full">
                        <button
                          onClick={() => updateQty(item.id, item.qty - 1)}
                          className="w-7 h-7 flex items-center justify-center hover:bg-neutral-100 rounded-full"
                        >
                          <Minus className="w-3 h-3" />
                        </button>
                        <span className="w-7 text-center text-sm font-medium">{item.qty}</span>
                        <button
                          onClick={() => updateQty(item.id, item.qty + 1)}
                          className="w-7 h-7 flex items-center justify-center hover:bg-neutral-100 rounded-full"
                        >
                          <Plus className="w-3 h-3" />
                        </button>
                      </div>
                      <button
                        onClick={() => removeFromCart(item.id)}
                        className="text-neutral-400 hover:text-red-500 transition-colors"
                      >
                        <Trash2 className="w-4 h-4" />
                      </button>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          )}
        </div>

        {cart.length > 0 && (
          <div className="border-t p-5 space-y-3">
            <div className="flex items-center justify-between">
              <span className="text-neutral-600">Subtotal</span>
              <span className="text-xl font-bold text-neutral-900">{formatPrice(totalPrice)}</span>
            </div>
            <p className="text-xs text-neutral-500">Costurile de livrare se calculează la checkout.</p>
            <Link
              to="/checkout"
              onClick={() => setIsCartOpen(false)}
              className="block w-full text-center bg-amber-500 hover:bg-amber-600 text-white font-medium py-3 rounded-full transition-colors"
            >
              Finalizează comanda
            </Link>
            <Link
              to="/cos"
              onClick={() => setIsCartOpen(false)}
              className="block w-full text-center bg-white border border-neutral-300 hover:border-amber-500 text-neutral-800 font-medium py-3 rounded-full transition-colors"
            >
              Vezi coșul
            </Link>
          </div>
        )}
      </aside>
    </>
  );
};

export default CartDrawer;
